type iOrganizationType= Readonly<"PERSON" | "DEPARTMENT" | "ZONE"| "GRADE"| "PHYSICALCLAZZ"| "TEACHINGCLAZZ">
type iUserType = Readonly<"TEACHER" | "STUDENT" | "PARENT">
export default class PersonItem {
    /**
     * 用户ID
     */
    public id: string;
    /**
     * 用户名
     */
    public name: string;
    /**
     * 用户编号，学生学号，教职工编号
     */
    public no: string;
    /**
     * 组选择器类型
     */
    public selectType: string;
    /**
     * 用户对象为所属组织ID，
     * 组织对象为上级组织ID
     */
    public organizationId: string;
    /**
     * 用户（person）|组织(organization)
     */
    public itemType: iUserType;
    /**
     * 组织类型，item为用户时为OrganizationType.PERSON
     */
    public organizationType: iOrganizationType;
    /**
    * 手机
    */
    public personNumber: string;
   
    constructor({
        id = '',
        name = '',
        no = '',
        selectType = '',
        organizationId = '',
        organizationType = '',
        personNumber = '',
    } = {}) {
        this.id = id;
        this.name = name||'';
        this.no = no||'';
        this.selectType = selectType;
        this.organizationId = organizationId;
        this.organizationType = organizationType as iOrganizationType;
        this.personNumber = personNumber;
    }
}